<template>
  <div></div>
</template>
<script>
import moment from "moment";
import Bus from "../bus";
export default {
  data() {
    return {
      passwordExpires: null
    };
  },
  created() {
    this.passwordExpires = this.$store.state.auth.password_expires;
  },
  mounted() {
    this.passwordExpires = this.$store.state.auth.password_expires;
  },
  computed: {
    passwordDaysLeft() {
      if (this.passwordExpires !== null) {
        var passwordExpires = this.passwordExpires;

        var a = moment(passwordExpires);
        var b = moment();

        return a.diff(b, "days");
      }
    },
    passwordExpireMessage() {
      if (this.passwordDaysLeft) {
        if (this.passwordDaysLeft > 1) {
          return (
            "IMPORTANT: " +
            this.passwordDaysLeft +
            " days left until your password expires. Please update your password now."
          );
        } else if (this.passwordDaysLeft == 1) {
          return (
            "IMPORTANT: " +
            this.passwordDaysLeft +
            " day left until your password expires. Please update your password now."
          );
        } else {
          return (
            "IMPORTANT: " +
            this.passwordDaysLeft +
            " days left until your password expires. Please update your password now."
          );
        }
      }
    },
    showExpireMessage() {
      if (this.passwordDaysLeft) {
        if (this.passwordDaysLeft <= 7) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    open() {
      this.passwordExpires = this.$store.state.auth.password_expires;
      if (this.showExpireMessage) {
        Bus.$emit("alert", {
          color: "warning",
          message: this.passwordExpireMessage
        });
      }
    }
  }
};
</script>
<style scoped>
.banner {
  background-color: yellow;
  font-weight: bold;
}
</style>